import { all, spawn } from 'redux-saga/effects';

import authSaga from 'features/auth/redux/saga';
import userSaga from 'features/user/redux/saga';
import dashboardSaga from 'features/dashboard/redux/saga';
import myGiftCardsSaga from 'features/my-gift-cards/redux/saga';
import subscriptionSaga from 'features/subscription/redux/saga';

function* sagas() {
  yield all([spawn(authSaga)]);
  yield all([spawn(userSaga)]);
  yield all([spawn(dashboardSaga)]);
  yield all([spawn(myGiftCardsSaga)]);
  yield all([spawn(subscriptionSaga)]);
}

export default sagas;
